import { DateTime } from 'luxon';
import HgChart from '../../../common/HgChart';
import { NumberUtils } from '../../../../common/numberUtils';
import { useTranslation } from 'react-i18next';

export interface ForecastLineChartProps {
  data?: { x: number; y: number }[];
}
export default function ForecastLineChart({ data }: ForecastLineChartProps) {
  const { i18n } = useTranslation();

  const chartData = {
    chart: {
      type: 'line',
      scrollablePlotArea: {
        minWidth: 400,
        scrollPositionX: 0.5,
      },
      panning: {
        enabled: true,
        type: 'x',
      },
    },
    credits: {
      enabled: false,
    },

    tooltip: {
      enabled: false,
    },
    title: {
      text: '',
    },
    legend: {
      enabled: false,
    },
    scrollbar: {
      enabled: true,
    },
    plotOptions: {
      series: {
        color: '#E2606A',
      },
    },
    xAxis: {
      categories: data?.map((item) =>
        DateTime.fromMillis(item.x, {
          locale: i18n.language,
        })
          .toJSDate()
          .toISOString()
      ),
      labels: {
        formatter: function (context: any) {
          return DateTime.fromISO(context.value, {
            locale: i18n.language,
          }).toFormat('MMMMM');
        },
      },
    },
    yAxis: {
      title: {
        text: null,
      },
    },
    series: [
      {
        name: 'budget',
        data: data?.map((item) => ({
          y: Number(NumberUtils.parse(item.y)),
        })),
        marker: {
          fillColor: '#FFFFFF',
          radius: 5,
          lineWidth: 2,
          lineColor: null, // inherit from series
        },
      },
    ],
  };

  return <HgChart className="budget-line-chart" chartData={chartData} />;
}
